import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import * as RecordRTC from 'recordrtc';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.scss']
})
export class ImageDialogComponent implements OnInit {
 	
  private file=null;

  constructor(public dialogRef: MatDialogRef<ImageDialogComponent>,private domSanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  onClose() {
    this.dialogRef.close();
  }

	fileChange(event) {
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {
      this.file = fileList[0]
    }
	}

  deleteImage(){
  	this.file=null;
  }

  onSave() {
    this.dialogRef.close(this.file);
  }
}
